import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import PracticeSingleDetailsOne from '../../components/practice-components/PracticeSingleDetailsOne';
import FooterOne from '../../common/footer/FooterOne';

const PracticeSingleOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Practice Single 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Practice Single 1"
        />
        
        <PracticeSingleDetailsOne />
        
        <FooterOne />
        </>
    )
}
    
export default PracticeSingleOne;